import { Injectable } from '@angular/core';
import { Actions,  createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as CourseActions from './course.actions';
import { of } from 'rxjs';
import { CourseService } from '../services/course.service';

@Injectable()
export class CourseEffects {

  constructor(private actions$: Actions,
    private courseService: CourseService) {}

    addToCartEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CourseActions.getCourseActivity),
        switchMap((action) =>
          this.courseService.getCourseActivity(action.courseId).pipe(
            map(course => {
              return CourseActions.getCourseActivitySuccess( course )
            }),
            catchError(() => of(CourseActions.getCourseActivityFailure({ error: 'Error getting course Activity' })))
          )
        )
      )
    );


    setCurrentLessonStatusEffect$ = createEffect(() =>
      this.actions$.pipe(
        ofType(CourseActions.setCurrentLessonStatus),
        switchMap((action) =>
          this.courseService.updateLessonStatus(action.lessonId, action.status).pipe(
            map(course => {
              return CourseActions.setCurrentLessonStatusSuccess( course, action.lessonId )
            }),
            catchError(() => of(CourseActions.getCourseActivityFailure({ error: 'Error getting course Activity' })))
          )
        )
      )
    );
}
